// Configuración centralizada de rutas y roles
export const routesConfig = [
    // USERS
    {
        path: "/users",
        roles: [3],
        title: "Usuarios",
        description: "Inactivar usuarios, Editar usuarios, actualizar información salarial y actualizar aprobadores.",
        component: "Users",
        breadcrumbs: [
            { name: "Inicio", url: "/", isActive: false },
            { name: "Usuarios", url: "/users", isActive: true },
            { name: "Agregar usuario", url: "/AddUser", isActive: false }
        ],
        features: [
            {
                name: "Agregar usuario",
                url: '/adduser'
            }
        ]
    },
    // ADD USER
    {
        path: "/adduser",
        roles: [3],
        title: "Agregar Usuario",
        description: "Crear nuevos usuarios en el sistema",
        component: "AddUser",
        breadcrumbs: [
            { name: "Inicio", url: "/", isActive: false },
            { name: "Usuarios", url: "/users", isActive: false },
            { name: "Agregar usuario", url: "/AddUser", isActive: true }
        ],
        showInHome: false // No mostrar en Home, es una sub-ruta
    },
    // EDIT USER
    {
        path: "/editUser/:id",
        roles: [3],
        title: "Editar Usuario",
        description: "Editar información de usuarios existentes",
        component: "EditUser",
        breadcrumbs: [
            { name: "Inicio", url: "/", isActive: false },
            { name: "Usuarios", url: "/users", isActive: false },
            { name: "Editar usuario", url: "", isActive: true }
        ],
        showInHome: false // No mostrar en Home, es una sub-ruta
    },
    // CONCEPTS
    {
        path: "/concepts",
        roles: [2, 3],
        title: "Conceptos",
        description: "Inactivar conceptos, Editar conceptos.",
        component: "Concepts",
        breadcrumbs: [
            { name: "Inicio", url: "/", isActive: false },
            { name: "Conceptos", url: "/concepts", isActive: true },
            { name: "Agregar concepto", url: "/AddConcept", isActive: false }
        ],
        features: [
            {
                name: "Agregar concepto",
                url: '/addconcept'
            }
        ]
    },
    // ADD CONCEPT
    {
        path: "/addconcept",
        roles: [2, 3],
        title: "Agregar Concepto",
        description: "Crear nuevos conceptos en el sistema",
        component: "AddConcept",
        breadcrumbs: [
            { name: "Inicio", url: "/", isActive: false },
            { name: "Conceptos", url: "/concepts", isActive: false },
            { name: "Agregar concepto", url: "/AddConcept", isActive: true }
        ],
        showInHome: false // No mostrar en Home, es una sub-ruta
    },
    // EDIT CONCEPT
    {
        path: "/editConcept/:id",
        roles: [2, 3],
        title: "Editar Concepto",
        description: "Editar información de conceptos existentes",
        component: "EditConcept",
        breadcrumbs: [
            { name: "Inicio", url: "/", isActive: false },
            { name: "Conceptos", url: "/concepts", isActive: false },
            { name: "Editar concepto", url: "", isActive: true }
        ],
        showInHome: false // No mostrar en Home, es una sub-ruta
    },
     // SUBCONCEPTS
    {
        path: "/subconcepts",
        roles: [2, 3],
        title: "Subconceptos",
        description: "Inactivar subconceptos, Editar subconceptos.",
        component: "SubConcepts",
        breadcrumbs: [
            { name: "Inicio", url: "/", isActive: false },
            { name: "Subconceptos", url: "/subconcepts", isActive: true },
            { name: "Agregar subconcepto", url: "/addsubconcept", isActive: false }
        ],
        features: [
            {
                name: "Agregar subconcepto",
                url: '/addsubconcept'
            }
        ]
    },
    // ADD SUBCONCEPT
    {
        path: "/addsubconcept",
        roles: [2, 3],
        title: "Agregar Subconcepto",
        description: "Crear nuevos subconceptos en el sistema",
        component: "AddSubConcept",
        breadcrumbs: [
            { name: "Inicio", url: "/", isActive: false },
            { name: "Subconceptos", url: "/subconcepts", isActive: false },
            { name: "Agregar subconcepto", url: "/addsubconcept", isActive: true }
        ],
        showInHome: false // No mostrar en Home, es una sub-ruta
    },
    // EDIT SUBCONCEPT
    {
        path: "/editSubConcept/:id",
        roles: [2, 3],
        title: "Editar Subconcepto",
        description: "Editar información de subconceptos existentes",
        component: "EditSubConcept",
        breadcrumbs: [
            { name: "Inicio", url: "/", isActive: false },
            { name: "Subconceptos", url: "/subconcepts", isActive: false },
            { name: "Editar subconcepto", url: "", isActive: true }
        ],
        showInHome: false // No mostrar en Home, es una sub-ruta
    },
    // OVER TIME REQUESTS
    {
        path: "/overtime",
        roles: [1, 2, 3],
        title: "Solicitudes de tiempo extra pre-aprobadas",
        description: "Solicitar tiempo extra, ver estatus de las solicitudes, editar y eliminar solicitudes, ver movimientos",
        component: "OverTime",
        breadcrumbs: [
            { name: "Inicio", url: "/", isActive: false },
            { name: "Mis solicitudes de tiempo extra", url: "/overtime", isActive: true },
            { name: "Solicitar pago de tiempo extra", url: "/overtimerequest", isActive: true }
        ],
        features: []
    },
    // OVER TIME REQUESTS - CREATE/EDIT
    {
        path: "/overtimerequest/:id/:usrId?",
        roles: [1, 2, 3],
        title: "Solicitar tiempo extra",
        description: "Crear y editar solicitudes de tiempo extra",
        component: "OverTimeRequest",
        breadcrumbs: [
            { name: "Inicio", url: "/", isActive: false },
            { name: "Mis solicitudes de tiempo extra", url: "/overtime", isActive: false },
            { name: "Solicitar pago de tiempo extra", url: "/overtimerequest", isActive: true }
        ],
        showInHome: false // No mostrar en Home, es una sub-ruta
    },
    // REQUESTS PENDING APPROVAL
    {
        path: "/requestspendingapproval",
        roles: [2, 3],
        title: "Aprobar tiempo extra",
        description: "Aprobar tiempo extra, Editar tiempo extra.",
        component: "RequestsPendingApproval",
        breadcrumbs: [
            { name: "Inicio", url: "/", isActive: false },
            { name: "Tiempo extra pendiente de aprobar", url: "/requestspendingapproval", isActive: true }
        ],
        features: []
    },
    // REQUESTS PENDING TO PAY
    {
        path: "/requestspendingtopay",
        roles: [3],
        title: "Solicitudes pendientes de pagar",
        description: "Ver solicitudes aprobadas, Cambiar estatus de las solicitudes a pagadas o rechazadas",
        component: "RequestsPendingToPay",
        breadcrumbs: [
            { name: "Inicio", url: "/", isActive: false },
            { name: "Tiempo extra pendiente de pagar", url: "/requestspendingtopay", isActive: true }
        ],
        features: []
    },
    // MANAGE REQUESTS
    {
        path: "/managerequests",
        roles: [3],
        title: "Administrar solicitudes",
        description: "Activar, desactivar y eliminar solicitudes",
        component: "ManageRequests",
        breadcrumbs: [
            { name: "Inicio", url: "/", isActive: false },
            { name: "Administrar solicitudes", url: "/managerequests", isActive: true }
        ],
        layoutProps: { fluid: true },
        features: []
    },
    // REPORTS SEMANAL
    {
        path: "/allrequests",
        roles: [3],
        title: "Reporte semanal",
        description: "Ver todas las solicitudes del sistema",
        component: "AllRequests",
        breadcrumbs: [
            { name: "Inicio", url: "/", isActive: false },
            { name: "Todas las solicitudes", url: "/AllRequests", isActive: true }
        ],
        showInHome: false, // Se muestra en el grupo de reportes
        parentGroup: "reports"
    },
    // GENERAL PAYMENT REPORT
    {
        path: "/GeneralPaymentReport",
        roles: [3],
        title: "Reporte general de pagos",
        description: "Reporte consolidado de todos los pagos",
        component: "GeneralPaymentReport",
        breadcrumbs: [
            { name: "Inicio", url: "/", isActive: false },
            { name: "Reporte general de pagos", url: "/GeneralPaymentReport", isActive: true }
        ],
        showInHome: false, // Se muestra en el grupo de reportes
        parentGroup: "reports"
    },
    // ANUAL REQUESTS
    {
        path: "/anualrequests",
        roles: [3],
        title: "Reporte Anual",
        description: "Ver todas las solicitudes del sistema",
        component: "AnualRequests",
        breadcrumbs: [
            { name: "Inicio", url: "/", isActive: false },
            { name: "Reporte anual", url: "/anualrequests", isActive: true }
        ],
        showInHome: false, // Se muestra en el grupo de reportes
        parentGroup: "reports"
    },
    {
        path: "/",
        roles: [1, 2, 3],
        title: "Inicio",
        description: "Página principal del sistema",
        component: "Home",
        showInHome: false // No mostrar en Home (es la propia Home)
    },
    {
        path: "/report",
        roles: [1, 2, 3],
        title: "Reportes personales",
        description: "Reportes específicos del usuario",
        component: "Report",
        showInHome: false // Ruta adicional, no mostrar en Home principal
    }
];

// Grupos especiales para Home (como el grupo de reportes)
export const homeGroups = [
    {
        roles: [3],
        title: "Reportes",
        mainUrl: null,
        description: "",
        features: [
            {
                name: "Reporte semanal",
                url: "/allrequests"
            },
            {
                name: "Reporte anual",
                url: "/anualrequests"
            },
            {
                name: "Reporte general de pagos",
                url: "/GeneralPaymentReport"
            },
        ]
    }
];

// Función para obtener rutas filtradas por rol para Home
export const getRoutesForHome = (roleId) => {
    const mainRoutes = routesConfig
        .filter(route =>
            route.roles.includes(roleId) &&
            route.showInHome !== false
        )
        .map(route => ({
            roles: route.roles,
            title: route.title,
            mainUrl: route.path,
            description: route.description,
            features: route.features || []
        }));

    // Agregar grupos especiales (como reportes)
    const specialGroups = homeGroups.filter(group =>
        group.roles.includes(roleId)
    );

    return [...mainRoutes, ...specialGroups];
};

// Función para obtener configuración de ruta específica
export const getRouteConfig = (path) => {
    return routesConfig.find(route => route.path === path);
};